import {IoMdArrowDropdownCircle} from "react-icons/io";

export function ButtonBlank(props) {
    const {children, onClick, style, type} = props;
    return <button type={type} onClick={onClick} style={style ? {
        ...style,

        color: 'inherit',
        border: 'none',
        padding: 0,
        font: 'inherit',
        cursor: 'pointer',
        outline: 'inherit',
        margin: 0,


    } : {
        background: 'none',
        color: 'inherit',
        border: 'none',
        padding: 0,
        font: 'inherit',
        cursor: 'pointer',
        outline: 'inherit',
        margin: 0,


    }}>{children}</button>
}